import axiosInstance from "../../../core/api/interceptors/axiosInterceptor";

// GET: List all offers
export const getOffers = async () => {
  const res = await axiosInstance.get("offers/get-offers", {
    suppressErrorToast: true,
  });
  return res.data;
};

// GET: Get offer by ID
export const getOffer = async (id) => {
  const res = await axiosInstance.get(`offers/get-offer/${id}`);
  return res.data;
};

// POST: Add new offer
export const addOffer = async (offer) => {
  const res = await axiosInstance.post("offers/add-offer", offer);
  return res.data;
};

// PUT: Update offer by ID
export const updateOffer = async (id, offer) => {
  const res = await axiosInstance.put(`offers/update-offer/${id}`, offer);
  return res.data;
};

// DELETE: Delete a line item from an offer
export const deleteOfferLineItem = async (offerId, lineItemId) => {
  const res = await axiosInstance.delete(`offers/${offerId}/line-items/${lineItemId}`);
  return res.data;
};

// DELETE: Delete offer by ID
export const deleteOffer = async (id) => {
  const res = await axiosInstance.delete(`offers/delete-offer/${id}`);
  return res.data;
};

// POST: Convert offer by ID
export const convertOffer = async (id) => {
  const res = await axiosInstance.post(`offers/convert-offer/${id}`);
  return res.data;
};
// ✅ New: Convert offer to invoice
export const convertOfferToInvoice = async (offerId) => {
  try {
    const response = await axiosInstance.post(`/offers/convert-offer/${offerId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Update offer status
export const updateOfferStatus = async (offerId, status) => {
  try {
    // Backend expects numeric status value (0=Draft, 1=Sent, 2=Accepted, 3=Converted, 4=Rejected)
    const statusValue = typeof status === 'number' ? status : 
      { 'Draft': 0, 'Sent': 1, 'Accepted': 2, 'Converted': 3, 'Rejected': 4 }[status];
    
    const response = await axiosInstance.patch(`offers/update-status/${offerId}`, { 
      Status: statusValue 
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Record payment for an offer
export const recordOfferPayment = async (paymentData) => {
  try {
    const res = await axiosInstance.post("offers/record-payment", paymentData);
    return res.data;
  } catch (error) {

    if (error.response?.data) return error.response.data;
    throw error;
  }
};